import { useSelector } from 'store';
import { useIsCofactr } from 'hooks/useIsCofactr';
import { useCallback } from 'react';

export default function useCreateLinkToRecord() {
  const { activeOrgId } = useSelector((state) => state.org);
  const { isCofactr } = useIsCofactr();

  const createLinkWithActiveOrgId = useCallback(
    (link: string) => {
      const url = new URL(link);
      if (isCofactr) {
        url.searchParams.set('activeorgid', activeOrgId || '');
      }
      return url.toString();
    },
    [activeOrgId, isCofactr]
  );

  return { createLinkWithActiveOrgId };
}
